// extracted by mini-css-extract-plugin
module.exports = {"item-timestamp":"timeline-entry-chat__item-timestamp___4hagX","item-body":"timeline-entry-chat__item-body___FiMJA"};